import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Currently fallback to NL.
// Can be removed if we support more languages.
if (localStorage.getItem("i18nextLng") === null) {
	localStorage.setItem("i18nextLng", "nl");
}

declare module "i18next" {
	interface CustomTypeOptions {
		returnNull: false;
	}
}

i18n.use(HttpApi)
	.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		returnNull: false,
		backend: {
			loadPath: "/locales/{{lng}}.json"
		},

		fallbackLng: "en",

		interpolation: {
			escapeValue: false
		},

		react: {
			useSuspense: false
		}
	});

export default i18n;
